export default {
  actions: {
    setQuestions({ dispatch }, { questionnaire, questions, deleted, autoProgress }) {
      this.$authorize('edit', 'Opportunity')

      return Vue.$http.patch(`admin/questionnaires/${questionnaire.id}`, {
        questions,
        deleted,
        autoProgress
      })
    }
  }
}
